// src/templates/templateTree.js

const templateTree = {
  en: [
    // ==================== INSTAGRAM REELS ====================
    {
  id: "instagram-reels",
  label: "Instagram Reels",
  icon: "🎬",
  hint: "Find and analyze reels content",
  children: [
    {
      id: "reels_smm_marketing",
      label: "SMM & Marketing",
      icon: "📱",
      children: [
        {
          id: "instagram_reels_smm_creators",
          label: "SMM Creators & Agencies",
          icon: "📈",
          hint: "Find SMM creators posting tips, strategies, case studies",
          templateId: "instagram_reels_smm_creators",
        },
        {
          id: "instagram_reels_ugc_creators",
          label: "UGC Creators",
          icon: "🎥",
          hint: "Find User-Generated Content creators for brands",
          templateId: "instagram_reels_ugc_creators",
        },
      ],
    },
    {
      id: "reels_ecommerce",
      label: "E-commerce & Retail",
      icon: "🛍️",
      children: [
        {
          id: "instagram_reels_ecommerce_fashion",
          label: "Fashion & Clothing",
          icon: "👗",
          hint: "Find fashion brands, boutiques, clothing stores",
          templateId: "instagram_reels_ecommerce_fashion",
        },
        {
          id: "instagram_reels_beauty_cosmetics",
          label: "Beauty & Cosmetics",
          icon: "💄",
          hint: "Find beauty brands, skincare, makeup",
          templateId: "instagram_reels_beauty_cosmetics",
        },
        {
          id: "instagram_reels_home_decor",
          label: "Home Decor & Furniture",
          icon: "🪑",
          hint: "Find interior design, home decor brands",
          templateId: "instagram_reels_home_decor",
        },
      ],
    },
    {
      id: "reels_food",
      label: "Food & Beverage",
      icon: "🍽️",
      children: [
        {
          id: "instagram_reels_food_restaurants",
          label: "Restaurants & Cafes",
          icon: "🍕",
          hint: "Find restaurants, cafes, food businesses",
          templateId: "instagram_reels_food_restaurants",
        },
        {
          id: "instagram_reels_food_creators",
          label: "Food Bloggers & Recipes",
          icon: "👨‍🍳",
          hint: "Find food creators, recipe developers",
          templateId: "instagram_reels_food_creators",
        },
      ],
    },
    {
      id: "reels_fitness",
      label: "Fitness & Wellness",
      icon: "💪",
      children: [
        {
          id: "instagram_reels_fitness_coaches",
          label: "Fitness Coaches & Trainers",
          icon: "🏋️",
          hint: "Find personal trainers, workout coaches",
          templateId: "instagram_reels_fitness_coaches",
        },
        {
          id: "instagram_reels_wellness_mindfulness",
          label: "Wellness & Mindfulness",
          icon: "🧘",
          hint: "Find yoga, meditation, wellness practitioners",
          templateId: "instagram_reels_wellness_mindfulness",
        },
      ],
    },
    {
      id: "reels_education",
      label: "Education & Coaching",
      icon: "📚",
      children: [
        {
          id: "instagram_reels_business_coaches",
          label: "Business Coaches",
          icon: "💼",
          hint: "Find business coaches, consultants, mentors",
          templateId: "instagram_reels_business_coaches",
        },
        {
          id: "instagram_reels_online_teachers",
          label: "Online Teachers & Courses",
          icon: "🎓",
          hint: "Find educators, tutors, course creators",
          templateId: "instagram_reels_online_teachers",
        },
      ],
    },
    {
      id: "reels_realestate",
      label: "Real Estate",
      icon: "🏠",
      children: [
        {
          id: "instagram_reels_real_estate",
          label: "Real Estate Agents",
          icon: "🏡",
          hint: "Find realtors, property agents, agencies",
          templateId: "instagram_reels_real_estate",
        },
      ],
    },
    {
      id: "reels_travel",
      label: "Travel & Hospitality",
      icon: "✈️",
      children: [
        {
          id: "instagram_reels_travel_creators",
          label: "Travel Creators & Bloggers",
          icon: "🌍",
          hint: "Find travel influencers, vloggers, bloggers",
          templateId: "instagram_reels_travel_creators",
        },
        {
          id: "instagram_reels_hotels_resorts",
          label: "Hotels & Resorts",
          icon: "🏨",
          hint: "Find hotels, resorts, accommodations",
          templateId: "instagram_reels_hotels_resorts",
        },
      ],
    },
    {
      id: "reels_tech",
      label: "Tech & SaaS",
      icon: "💻",
      children: [
        {
          id: "instagram_reels_saas_founders",
          label: "SaaS Founders & Startups",
          icon: "🚀",
          hint: "Find SaaS companies, startup founders",
          templateId: "instagram_reels_saas_founders",
        },
      ],
    },
    {
      id: "reels_local",
      label: "Local Businesses",
      icon: "📍",
      children: [
        {
          id: "instagram_reels_local_business",
          label: "Local Small Businesses",
          icon: "🏪",
          hint: "Find local shops, salons, services",
          templateId: "instagram_reels_local_business",
        },
      ],
    },
    {
      id: "reels_creative",
      label: "Creative & Art",
      icon: "🎨",
      children: [
        {
          id: "instagram_reels_artists_designers",
          label: "Artists & Designers",
          icon: "🖌️",
          hint: "Find visual artists, illustrators, designers",
          templateId: "instagram_reels_artists_designers",
        },
        {
          id: "instagram_reels_photographers",
          label: "Photographers",
          icon: "📸",
          hint: "Find professional photographers, videographers",
          templateId: "instagram_reels_photographers",
        },
      ],
    },
    {
      id: "instagram_reels_general_template",
      label: "General Reels Template",
      icon: "📈",
      hint: "Find trends in your niche via reels metrics",
      templateId: "instagram_reels_general_template",
    },
  ],
},

    // ==================== FIND CLIENTS ====================
    {
      id: "find-clients",
      label: "Find clients",
      icon: "🤝",
      hint: "Lead generation & commenting pipelines",
      children: [
        // --- Facebook ---
        {
          id: "find-clients-facebook",
          label: "Facebook",
          icon: "👥",
          hint: "Lead generation via Facebook posts — find people looking to hire",
          children: [
            {
              id: "smm_client_acquisition",
              label: "SMM",
              icon: "📱",
              hint: "Business owners looking for social media help",
              templateId: "smm_client_acquisition",
            },
            {
              id: "digital_marketing_client_acquisition",
              label: "Digital marketing",
              icon: "📊",
              hint: "Businesses needing Meta/Google ads help",
              templateId: "digital_marketing_client_acquisition",
            },
            {
              id: "seo_client_acquisition",
              label: "SEO",
              icon: "🔍",
              hint: "Businesses looking for SEO services",
              templateId: "seo_client_acquisition",
            },
            {
              id: "video_editor_client_acquisition",
              label: "Video editors",
              icon: "🎥",
              hint: "Businesses needing video editing",
              templateId: "video_editor_client_acquisition",
            },
            {
              id: "email_marketing_client_acquisition",
              label: "Email marketing",
              icon: "📧",
              hint: "Businesses needing email marketing",
              templateId: "email_marketing_client_acquisition",
            },
            {
              id: "copywriters_client_acquisition",
              label: "Copywriters",
              icon: "✍️",
              hint: "Businesses needing copywriting",
              templateId: "copywriters_client_acquisition",
            },
            {
              id: "ai_agency_client_acquisition",
              label: "AI agency",
              icon: "🤖",
              hint: "Businesses needing AI automation",
              templateId: "ai_agency_client_acquisition",
            },
            {
              id: "find-clients-designers",
              label: "Designers",
              icon: "🎨",
              hint: "Businesses needing design work",
              children: [
                {
                  id: "ux_ui_designers_client_acquisition",
                  label: "UX/UI design",
                  icon: "⚡",
                  hint: "Businesses needing UX/UI design",
                  templateId: "ux_ui_designers_client_acquisition",
                },
                {
                  id: "web_designers_client_acquisition",
                  label: "Web design",
                  icon: "⚡",
                  hint: "Businesses needing web design",
                  templateId: "web_designers_client_acquisition",
                },
                {
                  id: "motion_designers_client_acquisition",
                  label: "Motion design",
                  icon: "⚡",
                  hint: "Businesses needing motion design",
                  templateId: "motion_designers_client_acquisition",
                },
              ],
            },
            {
              id: "web_dev_nocode_client_acquisition",
              label: "Web dev / No-code",
              icon: "💻",
              hint: "Businesses needing website development or no-code solutions",
              templateId: "web_dev_nocode_client_acquisition",
            },
            {
              id: "ppc_google_ads_client_acquisition",
              label: "Google Ads / PPC",
              icon: "📈",
              hint: "Businesses looking for Google Ads specialists",
              templateId: "ppc_google_ads_client_acquisition",
            },
            {
              id: "tiktok_reels_creator_client_acquisition",
              label: "TikTok / Reels creator",
              icon: "🎵",
              hint: "Businesses needing short-form video content creation",
              templateId: "tiktok_reels_creator_client_acquisition",
            },
          ],
        },

        // --- LinkedIn ---
        {
          id: "find-clients-linkedin",
          label: "LinkedIn",
          icon: "💬",
          hint: "Find posts to comment on & build authority in your niche",
          children: [
            {
              id: "linkedin_smm_commenting",
              label: "SMM",
              icon: "📱",
              hint: "SMM posts worth commenting on",
              templateId: "linkedin_smm_commenting",
            },
            {
              id: "linkedin_digital_marketing_commenting",
              label: "Digital marketing",
              icon: "📊",
              hint: "Paid ads posts to engage with",
              templateId: "linkedin_digital_marketing_commenting",
            },
            {
              id: "linkedin_seo_commenting",
              label: "SEO",
              icon: "🔍",
              hint: "SEO discussions to join",
              templateId: "linkedin_seo_commenting",
            },
            {
              id: "linkedin_video_editing_commenting",
              label: "Video editing",
              icon: "🎥",
              hint: "Video production posts to engage with",
              templateId: "linkedin_video_editing_commenting",
            },
            {
              id: "linkedin_email_marketing_commenting",
              label: "Email marketing",
              icon: "📧",
              hint: "Email marketing discussions",
              templateId: "linkedin_email_marketing_commenting",
            },
            {
              id: "linkedin_copywriting_commenting",
              label: "Copywriting",
              icon: "✍️",
              hint: "Copywriting discussions",
              templateId: "linkedin_copywriting_commenting",
            },
            {
              id: "linkedin_ai_agency_commenting",
              label: "AI agency",
              icon: "🤖",
              hint: "AI/automation discussions",
              templateId: "linkedin_ai_agency_commenting",
            },
            {
              id: "linkedin_design_commenting",
              label: "Design",
              icon: "🎨",
              hint: "Design discussions",
              templateId: "linkedin_design_commenting",
            },
          ],
        },
      ],
    },
  ],

  pl: [
    // ==================== INSTAGRAM REELS ====================
    {
      id: "pl-instagram-reels",
      label: "Instagram Reels",
      icon: "🎬",
      hint: "Znajdź i analizuj treści rolek",
      children: [
        {
          id: "pl-reels_smm_marketing",
          label: "SMM i Marketing",
          icon: "📱",
          children: [
            {
              id: "instagram_reels_smm_creators_pl",
              label: "Twórcy i agencje SMM",
              icon: "📈",
              hint: "Znajdź twórców SMM publikujących porady, strategie, case studies",
              templateId: "instagram_reels_smm_creators_pl",
            },
            {
              id: "instagram_reels_ugc_creators_pl",
              label: "Twórcy UGC",
              icon: "🎥",
              hint: "Znajdź twórców treści UGC dla marek",
              templateId: "instagram_reels_ugc_creators_pl",
            },
          ],
        },
        {
          id: "pl-reels_ecommerce",
          label: "E-commerce i Handel",
          icon: "🛍️",
          children: [
            {
              id: "instagram_reels_ecommerce_fashion_pl",
              label: "Moda i odzież",
              icon: "👗",
              hint: "Znajdź marki modowe, butiki, sklepy odzieżowe",
              templateId: "instagram_reels_ecommerce_fashion_pl",
            },
            {
              id: "instagram_reels_beauty_cosmetics_pl",
              label: "Uroda i kosmetyki",
              icon: "💄",
              hint: "Znajdź marki kosmetyczne, pielęgnację, makijaż",
              templateId: "instagram_reels_beauty_cosmetics_pl",
            },
            {
              id: "instagram_reels_home_decor_pl",
              label: "Wystrój wnętrz i meble",
              icon: "🪑",
              hint: "Znajdź projektantów wnętrz, marki dekoracji",
              templateId: "instagram_reels_home_decor_pl",
            },
          ],
        },
        {
          id: "pl-reels_food",
          label: "Jedzenie i napoje",
          icon: "🍽️",
          children: [
            {
              id: "instagram_reels_food_restaurants_pl",
              label: "Restauracje i kawiarnie",
              icon: "🍕",
              hint: "Znajdź restauracje, kawiarnie, firmy spożywcze",
              templateId: "instagram_reels_food_restaurants_pl",
            },
            {
              id: "instagram_reels_food_creators_pl",
              label: "Blogerzy kulinarni i przepisy",
              icon: "👨‍🍳",
              hint: "Znajdź twórców kulinarnych, autorów przepisów",
              templateId: "instagram_reels_food_creators_pl",
            },
          ],
        },
        {
          id: "pl-reels_fitness",
          label: "Fitness i Wellness",
          icon: "💪",
          children: [
            {
              id: "instagram_reels_fitness_coaches_pl",
              label: "Trenerzy fitness i personalni",
              icon: "🏋️",
              hint: "Znajdź trenerów personalnych, instruktorów",
              templateId: "instagram_reels_fitness_coaches_pl",
            },
            {
              id: "instagram_reels_wellness_mindfulness_pl",
              label: "Wellness i mindfulness",
              icon: "🧘",
              hint: "Znajdź jogę, medytację, praktyków wellness",
              templateId: "instagram_reels_wellness_mindfulness_pl",
            },
          ],
        },
        {
          id: "pl-reels_education",
          label: "Edukacja i coaching",
          icon: "📚",
          children: [
            {
              id: "instagram_reels_business_coaches_pl",
              label: "Coachowie biznesowi",
              icon: "💼",
              hint: "Znajdź coachów biznesowych, konsultantów, mentorów",
              templateId: "instagram_reels_business_coaches_pl",
            },
            {
              id: "instagram_reels_online_teachers_pl",
              label: "Nauczyciele online i kursy",
              icon: "🎓",
              hint: "Znajdź edukatorów, korepetytorów, twórców kursów",
              templateId: "instagram_reels_online_teachers_pl",
            },
          ],
        },
        {
          id: "pl-reels_realestate",
          label: "Nieruchomości",
          icon: "🏠",
          children: [
            {
              id: "instagram_reels_real_estate_pl",
              label: "Agenci nieruchomości",
              icon: "🏡",
              hint: "Znajdź pośredników, agentów, agencje",
              templateId: "instagram_reels_real_estate_pl",
            },
          ],
        },
        {
          id: "pl-reels_travel",
          label: "Podróże i hotelarstwo",
          icon: "✈️",
          children: [
            {
              id: "instagram_reels_travel_creators_pl",
              label: "Twórcy podróżniczy i blogerzy",
              icon: "🌍",
              hint: "Znajdź influencerów podróżniczych, vlogerów, blogerów",
              templateId: "instagram_reels_travel_creators_pl",
            },
            {
              id: "instagram_reels_hotels_resorts_pl",
              label: "Hotele i ośrodki",
              icon: "🏨",
              hint: "Znajdź hotele, ośrodki, zakwaterowanie",
              templateId: "instagram_reels_hotels_resorts_pl",
            },
          ],
        },
        {
          id: "pl-reels_tech",
          label: "Tech i SaaS",
          icon: "💻",
          children: [
            {
              id: "instagram_reels_saas_founders_pl",
              label: "Founderzy SaaS i startupy",
              icon: "🚀",
              hint: "Znajdź firmy SaaS, founderów startupów",
              templateId: "instagram_reels_saas_founders_pl",
            },
          ],
        },
        {
          id: "pl-reels_local",
          label: "Firmy lokalne",
          icon: "📍",
          children: [
            {
              id: "instagram_reels_local_business_pl",
              label: "Lokalne małe firmy",
              icon: "🏪",
              hint: "Znajdź lokalne sklepy, salony, usługi",
              templateId: "instagram_reels_local_business_pl",
            },
          ],
        },
        {
          id: "pl-reels_creative",
          label: "Kreatywni i sztuka",
          icon: "🎨",
          children: [
            {
              id: "instagram_reels_artists_designers_pl",
              label: "Artyści i projektanci",
              icon: "🖌️",
              hint: "Znajdź artystów wizualnych, ilustratorów, grafików",
              templateId: "instagram_reels_artists_designers_pl",
            },
            {
              id: "instagram_reels_photographers_pl",
              label: "Fotografowie",
              icon: "📸",
              hint: "Znajdź profesjonalnych fotografów, kamerzystów",
              templateId: "instagram_reels_photographers_pl",
            },
          ],
        },
        {
          id: "instagram_reels_general_template_pl",
          label: "Szablon ogólny Rolek",
          icon: "📈",
          hint: "Znajdź trendy w swojej niszy przez metryki rolek",
          templateId: "instagram_reels_general_template_pl",
        },
      ],
    },

    // ==================== ZNAJDŹ KLIENTÓW ====================
    {
      id: "pl-find-clients",
      label: "Znajdź klientów",
      icon: "🤝",
      hint: "Generowanie leadów i pipeline komentowania",
      children: [
        {
          id: "pl-find-clients-facebook",
          label: "Facebook",
          icon: "👥",
          hint: "Generowanie leadów z postów Facebook — znajdź osoby szukające wykonawców",
          children: [
            { id: "smm_client_acquisition_pl", label: "SMM", icon: "📱", hint: "Właściciele firm szukający pomocy social media", templateId: "smm_client_acquisition_pl" },
            { id: "digital_marketing_client_acquisition_pl", label: "Marketing cyfrowy", icon: "📊", hint: "Firmy potrzebujące Meta/Google Ads", templateId: "digital_marketing_client_acquisition_pl" },
            { id: "seo_client_acquisition_pl", label: "SEO", icon: "🔍", hint: "Firmy szukające usług SEO", templateId: "seo_client_acquisition_pl" },
            { id: "video_editor_client_acquisition_pl", label: "Montaż wideo", icon: "🎥", hint: "Firmy potrzebujące montażu wideo", templateId: "video_editor_client_acquisition_pl" },
            { id: "email_marketing_client_acquisition_pl", label: "Email marketing", icon: "📧", hint: "Firmy potrzebujące email marketingu", templateId: "email_marketing_client_acquisition_pl" },
            { id: "copywriters_client_acquisition_pl", label: "Copywriting", icon: "✍️", hint: "Firmy potrzebujące copywritingu", templateId: "copywriters_client_acquisition_pl" },
            { id: "ai_agency_client_acquisition_pl", label: "Agencja AI", icon: "🤖", hint: "Firmy potrzebujące automatyzacji AI", templateId: "ai_agency_client_acquisition_pl" },
            {
              id: "pl-find-clients-designers",
              label: "Projektowanie",
              icon: "🎨",
              hint: "Firmy potrzebujące usług projektowych",
              children: [
                { id: "ux_ui_designers_client_acquisition_pl", label: "UX/UI design", icon: "⚡", hint: "Firmy potrzebujące UX/UI", templateId: "ux_ui_designers_client_acquisition_pl" },
                { id: "web_designers_client_acquisition_pl", label: "Web design", icon: "⚡", hint: "Firmy potrzebujące web designu", templateId: "web_designers_client_acquisition_pl" },
                { id: "motion_designers_client_acquisition_pl", label: "Motion design", icon: "⚡", hint: "Firmy potrzebujące motion designu", templateId: "motion_designers_client_acquisition_pl" },
              ],
            },
            { id: "web_dev_nocode_client_acquisition_pl", label: "Web dev / No-code", icon: "💻", hint: "Firmy potrzebujące stron lub no-code", templateId: "web_dev_nocode_client_acquisition_pl" },
            { id: "ppc_google_ads_client_acquisition_pl", label: "Google Ads / PPC", icon: "📈", hint: "Firmy szukające Google Ads", templateId: "ppc_google_ads_client_acquisition_pl" },
            { id: "tiktok_reels_creator_client_acquisition_pl", label: "Twórca TikTok / Reels", icon: "🎵", hint: "Firmy potrzebujące krótkich wideo", templateId: "tiktok_reels_creator_client_acquisition_pl" },
          ],
        },
        {
          id: "pl-find-clients-linkedin",
          label: "LinkedIn",
          icon: "💬",
          hint: "Znajdź posty do komentowania — buduj autorytet",
          children: [
            { id: "linkedin_smm_commenting_pl", label: "SMM", icon: "📱", hint: "Posty SMM warte skomentowania", templateId: "linkedin_smm_commenting_pl" },
            { id: "linkedin_digital_marketing_commenting_pl", label: "Marketing cyfrowy", icon: "📊", hint: "Posty o płatnych reklamach", templateId: "linkedin_digital_marketing_commenting_pl" },
            { id: "linkedin_seo_commenting_pl", label: "SEO", icon: "🔍", hint: "Dyskusje SEO", templateId: "linkedin_seo_commenting_pl" },
            { id: "linkedin_video_editing_commenting_pl", label: "Montaż wideo", icon: "🎥", hint: "Posty o produkcji wideo", templateId: "linkedin_video_editing_commenting_pl" },
            { id: "linkedin_email_marketing_commenting_pl", label: "Email marketing", icon: "📧", hint: "Dyskusje email marketing", templateId: "linkedin_email_marketing_commenting_pl" },
            { id: "linkedin_copywriting_commenting_pl", label: "Copywriting", icon: "✍️", hint: "Dyskusje copywriterskie", templateId: "linkedin_copywriting_commenting_pl" },
            { id: "linkedin_ai_agency_commenting_pl", label: "Agencja AI", icon: "🤖", hint: "Dyskusje AI/automatyzacja", templateId: "linkedin_ai_agency_commenting_pl" },
            { id: "linkedin_design_commenting_pl", label: "Projektowanie", icon: "🎨", hint: "Dyskusje o designie", templateId: "linkedin_design_commenting_pl" },
          ],
        },
      ],
    },
  ],
  
   
};

export default templateTree;